import { setBrandQuery } from "./setBrandQuery.js";


function init() {
    setBrandQuery();
}

export {
    init
}